(function () {

    var linkFunction = function ($scope, element, attrs) {

    }

    var controllerFunction = function ($scope, UserSession, webAnalytics, loggerService, loggerServiceHelper) {


        $scope.checkNative = cvsUtility.setNativeCheck();
        $scope.mobileAppStyle = cvsUtility.queryMap.mobileAppStyle ? true : false;

        // US544588 - UI | Enable ViewPaymentHistory in mobile apps IOS and Andriod 
        $scope.goToPaymentHistory = function () {
            if (cvsUtility.queryMap.env !== 'local') {
                var utagObj = {};
                utagObj.link_name = 'custom: account balance: open payment history button';
                utagObj.link_trackvars = 'events';
                utagObj.link_trackevents = 'event00';
                webAnalytics.webTrendsUtag("LINK", utagObj, undefined);

                if (cvsUtility.queryMap.mobileAppStyle == "true") {
                    window.location.href = window.location.origin + '/FASTPROXY/ngx-payments/#/payment-history' + window.location.search;
                } else {
                    window.location.href = window.location.origin + '/FASTPROXY/ngx-payments/#/payment-history';
                }
            }
        };

        $scope.webLogin = function () {
            if (cvsUtility.queryMap.mobileAppStyle == "true") {
                var utagObj = {};
                utagObj.link_name = 'custom: account balance: log in from web browser';
                utagObj.link_trackvars = 'events';
                utagObj.link_trackevents = 'event00';
                webAnalytics.webTrendsUtag("LINK", utagObj, undefined);
                
                if ($scope.checkNative) { // to set the opeExtUrl native method
                    var url = CVS.Config.parentHost.Web[cvsUtility.queryMap.env] + '/FASTPROXY/authentication/#/login';
                    native.openExtUrl(url);
                }
            }
        };


    }

    var directiveFunction = function () {
        return {
            restrict: 'E',
            templateUrl: '../payments/app/components/viewPaymentHistory/viewPaymentHistory.template.html',
            controller: controllerFunction,
            link: linkFunction
        }

    }

    controllerFunction.$inject = ["$scope", "userSession", "webAnalytics", "loggerService", "loggerServiceHelper"];

    angular.module('cvsApp').directive('viewPaymentHistory', directiveFunction);


})();